import type { SupportedLanguage } from './index'

export const localizedRoutes = {
  home: { it: '', en: '', fr: '', de: '', es: '', pt: '' },
  about: { it: 'chi-siamo', en: 'about', fr: 'a-propos', de: 'ueber-uns', es: 'quienes-somos', pt: 'sobre-nos' },
  technicalAssistance: { it: 'assistenza-tecnica', en: 'technical-assistance', fr: 'assistance-technique', de: 'technische-assistenz', es: 'asistencia-tecnica', pt: 'assistencia-tecnica' },
  equipmentSales: { it: 'vendita-strumentazione', en: 'equipment-sales', fr: 'vente-instruments', de: 'geraeteverkauf', es: 'venta-instrumentacion', pt: 'venda-instrumentacao' },
  pumpRepair: { it: 'riparazione-pompe', en: 'pump-repair', fr: 'reparation-pompes', de: 'pumpenreparatur', es: 'reparacion-bombas', pt: 'reparacao-bombas' },
  calmix: { it: 'calmix', en: 'calmix', fr: 'calmix', de: 'calmix', es: 'calmix', pt: 'calmix' },
  products: { it: 'prodotti', en: 'products', fr: 'produits', de: 'produkte', es: 'productos', pt: 'produtos' },
  partners: { it: 'partners', en: 'partners', fr: 'partenaires', de: 'partner', es: 'socios', pt: 'parceiros' },
  contacts: { it: 'contatti', en: 'contacts', fr: 'contact', de: 'kontakt', es: 'contacto', pt: 'contacto' },
  privacy: { it: 'privacy', en: 'privacy', fr: 'confidentialite', de: 'datenschutz', es: 'privacidad', pt: 'privacidade' },
} as const

export type RouteKey = keyof typeof localizedRoutes

export function getLocalizedPath(
  routeKey: RouteKey,
  lang: SupportedLanguage
): string {
  const path = localizedRoutes[routeKey][lang]
  return path ? `/${lang}/${path}` : `/${lang}`
}

export function findRouteKeyFromPath(
  pathSegment: string,
  lang: SupportedLanguage
): RouteKey | null {
  for (const [key, routes] of Object.entries(localizedRoutes)) {
    if (routes[lang as keyof typeof routes] === pathSegment) {
      return key as RouteKey
    }
  }
  return null
}
